import { ToastContainer } from "react-toastify";
import PathRouter from "Route/PathRouter";
import "remixicon/fonts/remixicon.css";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";

function App() {
  return (
    <div>
      <PathRouter />
      <ToastContainer
        hideProgressBar={true}
        newestOnTop={true}
        pauseOnFocusLoss={false}
        pauseOnHover={true}
        autoClose={5000}
      />
    </div>
  );
}

export default App;
